import React, { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import './index.scss'
import App from './routes/App'
import reportWebVitals from './reportWebVitals'
import { BrowserRouter } from 'react-router-dom'
import { Provider } from 'react-redux'
import store, { persistor } from './redux'
import { PersistGate } from 'redux-persist/integration/react'
import ConfigProvider from './AndtConfigProvider'
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
root.render(
	<Provider store={store}>
		<BrowserRouter>
			<PersistGate loading={null} persistor={persistor}>
				<ConfigProvider>
					<StrictMode>
						<App />
					</StrictMode>
				</ConfigProvider>
			</PersistGate>
		</BrowserRouter>
	</Provider>
)

reportWebVitals()
